<div class="input-container">
    <div [ngSwitch]="activeInputMenuItem">
        <div class="input-content" *ngSwitchCase="'Kak Pot'">
            <ngx-screen-width></ngx-screen-width>
        </div>
        <div class="input-content" *ngSwitchCase="'Pallete'">
            <ngx-pallette></ngx-pallette>
        </div>
        <div class="input-content" *ngSwitchDefault>
            <nb-tabset (changeTab)="tabChanged($event)">
                <nb-tab tabTitle={{defaultInputMenuItem}}>
                    <ngx-screen-width></ngx-screen-width>
                </nb-tab>
                <nb-tab tabTitle="Sections">
                    <ngx-pallette></ngx-pallette>
                </nb-tab>
            </nb-tabset>
        </div>
    </div>
</div>
<!-- <div class="input-container">
    <div class="input-content">
        <nb-tabset (changeTab)="tabChanged($event)">
            <nb-tab tabTitle={{defaultInputMenuItem}}>
                <ngx-screen-width></ngx-screen-width>
            </nb-tab>
            <nb-tab tabTitle="Sections">
                <ngx-pallette></ngx-pallette>
            </nb-tab>
        </nb-tabset>
    </div>
</div> -->
